import { BenchmarkTypeOf } from "@modules/benchmark/benchmarkTypes"
import { Config } from "@modules/config"
import { word } from "@modules/core/utils/i18n"
import { CrossfitEventCard } from "@modules/crossfitEvent/components/crossfitEventCard"
import { useCrossfitEvents } from "@modules/crossfitEvent/hooks/useCrossfitEvent"
import { BenchmarkHeroesCard } from "@modules/dashboard/components/cards/benchmarkHeroesCard"
import { dataHeroesBenchmark } from "@modules/dashboard/mockHeroesBenchmark"
import { useHome } from "@modules/home/hooks/useHome"
import { useMemo } from "react"
import { Text } from "@/components/ui/baseUi/text"
import { LoaderCircle } from "lucide-react"
import {
  Carousel,
  CarouselItem,
  CarouselIndicators,
  CarouselContent,
  CarouselIndicator,
} from "@/components/ui/baseUi/carousel"
import type { CrossFitEvent } from "@/modules/crossfitEvent/entities/crossfitEventEntity"
import { cn } from "@/modules/lib/utils"

const benchmarkOpen25 = [
  {
    type: BenchmarkTypeOf,
    id: "34ad8f5b19ae43f59b65f61e3b18aeca",
  },
  {
    type: BenchmarkTypeOf,
    id: "e6c53647f7c040eea14d1d177e433175",
  },
  {
    type: BenchmarkTypeOf,
    id: "1d9271718c884ecb88de8c1de36d404f",
  },
]

type RightNowResumeProps = {
  className?: string
} & React.ComponentProps<"div">

export function RightNowResume({ className, ...props }: RightNowResumeProps) {
  const { crossfitEventsList, isLoading } = useCrossfitEvents()
  const { homeContent } = useHome()
  const description = homeContent?.getRightNowDescription() ?? ""
  const shouldDisplayEvents = useMemo(
    () => homeContent?.shouldDisplayEvents() && crossfitEventsList && crossfitEventsList.length > 0,
    [crossfitEventsList, homeContent],
  )

  const dataList = shouldDisplayEvents
    ? crossfitEventsList
    : Config.ENV === "prod"
      ? benchmarkOpen25
      : dataHeroesBenchmark

  return (
    <div className={cn("flex flex-col gap-2", className)} {...props}>
      <div className="mb-2 flex w-full items-center justify-between">
        <Text fontStyle="TL">{word("home.screen.right_now.title")}</Text>
      </div>
      <div className="flex w-full flex-col gap-2">
        <Text fontStyle="BS" color="var(--color-neutral-700)">
          {description}
        </Text>
        <div className="flex w-full flex-col items-center justify-center gap-2">
          {isLoading ? (
            <LoaderCircle className="animate-spin" />
          ) : dataList ? (
            <Carousel className="w-full max-w-[320px]" opts={{ align: "start", loop: true }}>
              <CarouselContent>
                {dataList.map((item, idx) => (
                  <CarouselItem key={shouldDisplayEvents ? (item.id ?? idx) : idx} className="flex justify-center">
                    {shouldDisplayEvents ? (
                      <CrossfitEventCard crossfitEvent={item as CrossFitEvent} />
                    ) : (
                      <BenchmarkHeroesCard heroesBenchmark={item} />
                    )}
                  </CarouselItem>
                ))}
              </CarouselContent>
              <CarouselIndicators className="mt-2">
                {dataList.map((_, idx) => (
                  <CarouselIndicator key={idx} index={idx} />
                ))}
              </CarouselIndicators>
            </Carousel>
          ) : null}
        </div>
      </div>
    </div>
  )
}
